import { render, staticRenderFns } from "./noticecomponent.vue?vue&type=template&id=85b83e3a&scoped=true&"
import script from "./noticecomponent.vue?vue&type=script&lang=js&"
export * from "./noticecomponent.vue?vue&type=script&lang=js&"
import style0 from "./noticecomponent.vue?vue&type=style&index=0&id=85b83e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b83e3a",
  null
  
)

export default component.exports